export enum AlexiRoutes {
  CALLBACK = 'callback',
  LOAN_APPLICATION = 'application',
  LOAN_APPLICATION_AGENT = 'agent-application',
  LOGIN = 'login',
  DASHBOARD = 'dashboard',
  SG_ONBOARDING = 'sg-kyb',
  SG_VENDORS_ONBOARDING = 'sg-vendors-onboarding',
  PARTNER_CONNECT = 'partnerconnect',
  CO_APPLICANT = 'co-applicant',
  CO_APPLICANT_KYB = 'co-applicant-kyb',
}
